export default "__VITE_ASSET__Ckhw6edM__"